export default __webpack_public_path__ + "static/media/10.81700d59.mp3";